import { TableColumn } from "../../../../components/ModularDataTable/types"
import { Input } from "../../../../components/Input/Input";
import { i18n } from "../../../../translate/i18n";
import { LojaAgregador } from "../type";


type Props = {
    switchStatus: (params: { endpoint: string, Id: number, status: boolean }) => void
}

export const createColumns = ({ switchStatus }: Props): TableColumn[] => {
    const columns: TableColumn[] = [
        {
            key: i18n.t(`aggregador_publicity.table.image`),
            value: 'shareImage',
            type: 'custom',
            render: (_value: any, row: LojaAgregador) => (
                <img src={row.image} style={{ width: `50px`, height: '50px', objectFit: "cover", borderRadius: '10px' }} />

            ),
        },
        {
            key: i18n.t(`aggregador_publicity.table.title`),
            value: 'name',
            type: 'text',
        },
        {
            key: i18n.t(`aggregador_publicity.table.description`),
            value: 'description',
            type: 'text',
        },
         
        {
            key: i18n.t(`aggregador_publicity.table.status`),
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: LojaAgregador) => (
                <div>
                    <Input
                        value={row.active}
                        checked={row.active}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
    ]

    return columns
}